export default __webpack_public_path__ + "static/level-04404f3fd21d8ca3b13895ccc6d79fb4.gif";